import PropTypes from "prop-types";
import React from "react";
import {useFormikContext} from "formik";

/**
 * Renders an error message.
 * @param name the field name
 * @returns {JSX.Element|null}
 */
const ErrorMessage = ({name}) => {
  const {errors} = useFormikContext();

  if (errors[name]) {
    return (<span className="sp-form-error-message">{errors[name].join(", ")}</span>);
  } else {
    return null;
  }
};

ErrorMessage.propTypes = {
  name: PropTypes.string.isRequired,
};

export default ErrorMessage;
